import { TwoUpTockProps } from "@bluebottlecoffee/design-system/components/modules/TwoUp/components";
import { toHTML } from "@portabletext/to-html";
import { Tock } from "../sanity-schema";

export const toTockProps = (
  data: Tock,
  region: string,
  lang: string,
): TwoUpTockProps => ({
  copyBlockProps: {
    heading: data.copyBlock?.heading && data.copyBlock.heading[lang],
    subheading:
      data.copyBlock?.subheading && toHTML(data.copyBlock.subheading[lang]),
    description:
      data.copyBlock?.description && toHTML(data.copyBlock.description[lang]),
  },
  TockComponent: data.enabled ? (
    <div
      id="Tock_widget_container"
      data-tock-display-mode="Inline"
      data-tock-color-mode="Blue"
      data-tock-locale="en-us"
      data-tock-timezone="America/Los_Angeles"
      data-tock-offering={data.tockEventId}
    />
  ) : null,
});
